const PIXEL_ID = '962279486187488'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

let initialized = false

/** Loads the Meta Pixel script (once) and fires the initial PageView. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  if (!window.fbq) {
    const fbq: Window['fbq'] = function (...args: unknown[]) {
      if (fbq!.callMethod) {
        fbq!.callMethod.apply(fbq, args)
      } else {
        fbq!.queue!.push(args)
      }
    } as NonNullable<Window['fbq']>

    window.fbq = fbq
    window._fbq = fbq
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/** Fires AddToCart right before sending the visitor to the Shopify cart. */
export function trackAddToCart(): void {
  window.fbq?.('track', 'AddToCart', {
    content_name: 'Manual de Autosanación Energética',
    content_ids: ['42871928684629'],
    content_type: 'product',
    value: 9.99,
    currency: 'USD',
  })
}
